<template>
  <div class="wycMain">
    <div>
      <el-input v-model="getTitle" class="input"></el-input>
    </div>
    <iframe id="_5118_Wyc_Box" :src="wycUrl" class="iframe"></iframe>
    <WycListBtn
      :class="[
        !rightShow
          ? contentWidth < 1600
            ? contentWidth < 1400
              ? 'listbutton3'
              : 'listbutton2'
            : 'listbutton'
          : contentWidth < 1400
          ? 'listbutton4'
          : 'listbutton1'
      ]"
    ></WycListBtn>
  </div>
</template>

<script>
import WycListBtn from "../edit/WycListBtn";
import { SendPostData } from "../../assets/script/model/index";
import config from "../../assets/script/config/index.js";
import edControl from "../../assets/script/utils/editorControl.js";
// import Cookies from "js-cookie";
import { mapState, mapMutations } from "vuex";
export default {
  name: "WycContent",
  data() {
    return {
      wycUrl: "" // "http://d-wyc.5118.com/ai?token=" + this.userInfo.token,
      // wycUrl:
      //   "http://d-wyc.5118.com/ai?token=987B18A18B0FD800907EBD92D8828CF21C63864AD483829472D64D6DBD519ADE806B831F9553B965"
    };
  },
  components: {
    WycListBtn
  },
  computed: {
    ...mapState("user", ["userToken"]),
    ...mapState("wycContent", ["isShow"]),
    insertDoc: {
      get() {
        return this.$store.state.editorControl.insertDoc;
      }
    },
    wycContent: {
      get() {
        return this.$store.state.wycContent.wycContent;
      },
      set(val) {
        this.$store.state.wycContent.wycContent = val;
      }
    },
    getTitle: {
      get() {
        return this.$store.state.wycContent.getTitle;
      },
      set(val) {
        this.$store.state.wycContent.getTitle = val;
      }
    },
    wycAbstract: {
      get() {
        return this.$store.state.wycContent.wycAbstract;
      },
      set(val) {
        this.$store.state.wycContent.wycAbstract = val;
      }
    },
    showMsg: {
      get() {
        return this.$store.state.wycContent.showMsg;
      },
      set(val) {
        this.$store.state.wycContent.showMsg = val;
      }
    },
    sendCount: {
      get() {
        return this.$store.state.wycContent.sendCount;
      },
      set(val) {
        this.$store.state.wycContent.sendCount = val;
      }
    },
    getSentenceTxt: {
      get() {
        return this.$store.state.wycContent.getSentenceTxt;
      },
      set(val) {
        this.$store.state.wycContent.getSentenceTxt = val;
      }
    },
    allContent: {
      get() {
        return this.$store.state.editorControl.allContent;
      },
      set(val) {
        this.$store.state.editorControl.allContent = val;
      }
    },
    editorShow: {
      get() {
        return this.$store.state.contents.editorShow;
      },
      set(val) {
        this.$store.state.contents.editorShow = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    contentWidth: {
      get() {
        return this.$store.state.contents.contentWidth;
      }
    },
    rightShow: {
      get() {
        return this.$store.state.contents.rightShow;
      },
      set(val) {
        this.$store.state.contents.rightShow = val;
      }
    },
    leftShow: {
      get() {
        return this.$store.state.contents.leftShow;
      },
      set(val) {
        this.$store.state.contents.leftShow = val;
      }
    },
    rightTitle: {
      get() {
        return this.$store.state.contents.rightTitle;
      },
      set(val) {
        this.$store.state.contents.rightTitle = val;
      }
    }
  },
  beforeDestroy() {
    this.wycShow = false;
    this.editorShow = true;
    this.userInfo = {};
  },
  watch: {
    wycContent: {
      handler(newVal) {
        let sendData = new SendPostData();
        if (this.sendCount === 0) {
          sendData.btn = "send";
          sendData.data = { txt: newVal };
        } else {
          sendData.btn = "use";
          let sendType = "after";
          sendData.data = { txt: newVal, insertSeat: sendType };
        }
        this.SendMessage(sendData);
        if (this.sendCount === 0) this.sendCount += 1;
      }
    },
    wycAbstract: {
      handler(newVal) {
        let sendData = new SendPostData();
        sendData.btn = "use";
        let sendType = "before";
        sendData.data = { txt: newVal, insertSeat: sendType };
        this.SendMessage(sendData);
      }
    },
    contentHeight: {
      handler(val) {
        this.getLineHeight(val);
      }
    }
  },
  mounted() {
    this.getToken();
    this.getid = setInterval(() => {
      let getBox = document.getElementById("_5118_Wyc_Box");
      if (getBox) {
        clearInterval(this.getid);
        this.getLineHeight(this.contentHeight);
        let getContent = localStorage.getItem("lastEditorContent");
        if (getContent) {
          if (getContent.indexOf('"title":') !== -1) {
            if (!this.getSessionDocId())
              if (this.$route.name !== "materialNew") {
                this.getTitle = JSON.parse(getContent).title;
              }
          } else {
            localStorage.setItem(
              "lastEditorContent",
              JSON.stringify(this.insertDoc)
            );
          }
        }

        // if (localStorage.getItem("lastEditorContent")) {
        //   this.getTitle = JSON.parse(
        //     localStorage.getItem("lastEditorContent")
        //   ).title;
        // }
      }
    }, 100);
    this.sendCount = 0;
    this.listenMessage();
  },
  // updated() {
  //   this.listenMessage();
  // },
  methods: {
    ...mapMutations("wycContent", ["setIsShow"]),
    getToken() {
      // this.userInfo = JSON.parse(Cookies.get("5ceinfo") || "{}") || {};
      //alert(JSON.parse(Cookies.get("5ceinfo")).token);
      this.wycUrl = config.wycLink + this.userToken;
    },
    listenMessage() {
      let that = this;
      // // 接收整句智能原创消息
      // this.$messenger.listen("_Set_New_Sentence", e => {
      //   console.log(e);
      //   that.rightShow = true;
      //   that.rightTitle = "整句原创";
      //   that.getCoreWords();
      // });

      window.addEventListener("message", function(e) {
        if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
          if (e.data.isclose && e.data.btn === "finish") {
            // if (e.data.data.txt !== "" && e.data.data.txt !== null) {
            //   that.allContent = e.data.data.txt;
            // }
            // that.allContent = e.data.data.txt;
            edControl.setAllContent(e.data.data.txt, "");
            that.editorShow = true;
            that.wycShow = false;
            that.sendCount = 0;
            that.rightShow = false;
            that.leftShow = true;
          }
          // if (!e.data.isclose && e.data.btn === "use") {
          //   // that.$message({
          //   //   message: that.showMsg,
          //   //   showClose: true,
          //   //   type: "success"
          //   // });
          //   console.log("操作完成");
          // }
          if (!e.data.isclose && e.data.btn === "send") {
            if (e.data.data.ErrorCode === 0) {
              that.editorShow = false;
              that.wycShow = true;
              that.rightShow = false;
              let isOk = false;
              that.setIsShow(isOk);
            } else {
              if (that.isShow) {
                let isOk = false;
                that.setIsShow(isOk);
                that.$message({
                  message: "智能原创分析失败",
                  showClose: true,
                  type: "error"
                });
              }
            }
          }
          if (!e.data.isclose && e.data.btn === "sentence") {
            that.rightShow = true;
            that.rightTitle = "整句原创";
            that.getCoreWords();
          }
        }
      });
    },
    getCoreWords() {
      let sendData = new SendPostData();
      sendData.btn = "sentencecoreword";
      this.sendNewMsg(sendData.btn, sendData.data);
      // this.SendMessage(sendData);
    },
    getLineHeight(newContentHeight) {
      let toolbar = document.querySelector(".el-header");

      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }
      let editorStatusBarHeight = 75;
      let realHeight =
        newContentHeight - editorToolbarHeight - editorStatusBarHeight;
      let getBox = document.getElementById("_5118_Wyc_Box");
      getBox.style.height = realHeight + "px";
      getBox.style.backgroundColor = "#fff";
    }
  }
};
</script>

<style lang="less" scoped>
.wycMain {
  min-width: 640px;
  max-width: 820px;
  width: 820px;
  text-align: center;
  margin: 0 auto;
  margin-top: 30px;
  .iframe {
    width: 820px;
    height: 700px;
    min-width: 640px;
    max-width: 820px;
  }
}
.listBtnMain {
  padding: 5px 10px;
  position: fixed;
  top: 26%;
}
.listbutton {
  .listBtnMain();
  margin-left: 810px;
}
.listbutton1 {
  .listBtnMain();
  margin-left: 790px;
}
.listbutton2 {
  .listBtnMain();
  margin-left: 780px;
}
.listbutton3 {
  .listBtnMain();
  margin-left: 720px;
}
.listbutton4 {
  .listBtnMain();
  margin-left: 750px;
}
/deep/.el-input__inner {
  width: 820px;
  margin-bottom: 10px;
  margin-top: 20px;
  font-size: 20px;
  font-weight: 900;
}
</style>
<style scoped>
/*- scrollbar -*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #999;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:vertical:hover {
  background-color: #666;
}
::-webkit-scrollbar-thumb:vertical:active {
  background-color: #333;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
</style>
